
      // Check if we're in an insecure context (HTTP) and crypto.subtle is not available
      (async function() {
        if (typeof window !== 'undefined' && (!window.crypto || !window.crypto.subtle)) {
          try {
            // Load webcrypto-liner-shim which bundles asmcrypto properly
            await import('webcrypto-liner-shim');
            console.log('Crypto polyfill shim loaded from index.html');
            // Give it a moment to patch
            await new Promise(resolve => setTimeout(resolve, 100));
          } catch (err) {
            console.error('Failed to load crypto polyfill from index.html:', err);
          }
        }
      })();
    